import React from 'react'
import s from './BackgroundCorners.module.scss'
import cx from 'classnames'
import TopCorner from "assets/images/2024-ui/top-right-corner.png"
import BottomCorner from "assets/images/2024-ui/bottom-left-corner.png"
import Accent from "assets/images/2024-ui/arc-accent.svg"

BackgroundCorners.defaultProps = {

}

export default function BackgroundCorners({id, className, active}) {

  return (
    <div id={id} className={cx(s.BackgroundCorners, className, {[s.active]: active})}>
      <img className={s.topCorner} src={TopCorner} alt="" />
      <img className={s.bottomCorner} src={BottomCorner} alt="" />
      <img className={s.accent} src={Accent} alt="" />
    </div>
  )
}
